<template>
  
  <div >
    <!-- <q-btn  style="width:100%"  @click="showPopup = !showPopup" label="Kein User angegeben" v-if="myModelValue==null"/>
    <q-btn  style="width:100%" @click="showPopup = !showPopup" :label="myModelValue.name" v-if="myModelValue"/>

    {{myModelValue}} -->
 
    <q-input outlined   :label="myLabel"  readonly  v-if="myModelValue==null">
        <template v-slot:append>
          <q-icon name="search" @click="toggle" class="cp"/>
        </template>
      </q-input>

    <q-input outlined v-model="myModelValue.name" :label="myLabel"  readonly  v-if="myModelValue" @click="toggle">
        <template v-slot:append>
          <q-icon name="search" class="cp"/>
        </template>
      </q-input> 



    <q-dialog
      v-model="showPopup"
      transition-show="fade"
      transition-hide="fade"
      class="scroll"
    >
      <q-card>
        <q-card-section>
          <div class="text-h6">{{ myLabel }}</div>
          <q-input outlined v-model="filterString" label="User suchen" ref="mysearch" />
        </q-card-section>
        <q-separator />
        <!-- <q-card-section class="q-pt-none"> -->
          <q-card-section style="height: 60vh;width:500px;" class="scroll">
          <q-virtual-scroll
            type="table"
            style="max-height: 6d0vh"
            :virtual-scroll-item-size="48"
            :virtual-scroll-sticky-size-start="48"
            :virtual-scroll-sticky-size-end="32"
            :items="tabledataComputed"
          >
            <template v-slot:before>
              <thead class="thead-sticky text-left">
                <tr>
                  <th>#</th>
                  <th>Vorname</th>
                  <th>Nachname</th>
                  <th>E-Mail</th>
                </tr>
              </thead>
            </template>

            <template v-slot="{ item: row, index }">
              <tr :key="index" @click="rowClicked(row, index)" class="cp">
                <td>{{ index + 1 }}</td>
                <td>{{ row.vorname }}</td>
                <td>{{ row.nachname }}</td>
                <td>{{ row.email }}</td>
              </tr>
            </template>
          </q-virtual-scroll>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Abbrechen" color="primary" v-close-popup />
          <!-- <q-btn flat label="Accept" color="primary" v-close-popup /> -->
        </q-card-actions>

        <q-card-actions align="left">
          <q-btn icon="delete" @click="entfernen"></q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import { ref, watch, inject, computed } from 'vue';

export default {
  props: {
    modelValue: Object,
    label: String,
    options: [],
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const myModelValue = ref(props.modelValue);
    const myLabel = ref(props.label);
    let showPopup = ref(false);
    let filterString = ref('');
    
     let mysearch = ref(null);
    let tabledata = ref([]);
    const web = inject('web');


    let myTimeout=null
    watch(
      () => filterString.value,
      (newVal) => {

        console.log(mysearch.value)
        if(myTimeout!==null){
          clearTimeout(myTimeout)

        }
        myTimeout = setTimeout(function(){
          reload()
        },250)
      console.log(newVal)      
    
    }
    );

    function update() {
      emit('update:modelValue', myModelValue.value);
    }
     async function reload() {
        let data = await web.post('/users', { searchText: filterString.value });
        console.log('sdddd', data);
        tabledata.value = data.users;
    }

    function rowClicked(row) {
      console.log('row', row);

      myModelValue.value = {
        name: row.vorname + ' ' + row.nachname,
        id_user: row._id,
      };

      // myModelValue.value.name=personObject.name
      emit('update:modelValue', myModelValue.value);
      showPopup.value = false;
    }
    // onMounted(() => {
    //   reload();
    // });

    function entfernen(){
      if(!confirm("Sicher?")) return;
      myModelValue.value=null
      emit('update:modelValue', null);
      showPopup.value = false;
    }

    let tabledataComputed = computed(() => {
      return tabledata.value.filter((row) => {
        var regex = new RegExp(filterString.value, 'gi');
        let longString = row.vorname+" "+row.nachname;
        return longString.match(regex);
      });
    });

    function toggle() {
      console.log('mysearch',mysearch)
      showPopup.value = !showPopup.value

      if(showPopup.value){

        setTimeout(() => {
          
          mysearch.value.focus()
        },200)
      }
    }

    return {
      tabledataComputed,
      filterString,
      rowClicked,
      showPopup,
      mysearch,
      update,
      myModelValue,
      myLabel,
      toggle,
      entfernen
    };
  },
};
</script>
